module.exports = __webpack_public_path__ + "img/ease_reg_bg.aed81a0.jpg";